// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Client V2 common imports
const { keyedReviver, listReviver } = require('client-v2/common/state/revivers')
// Sibling imports
const ToastsNoticeRecord = require('./records/notice')

class ToastsRecord extends Immutable.Record({
  lastId: Number(),
  notices: Immutable.List()
}) {
  findNoticeIndexById(noticeId) {
    return this.notices.findIndex(notice => {
      return notice.id == noticeId
    })
  }

  dismissNotice(noticeId) {
    const index = this.findNoticeIndexById(noticeId)
    if (index === -1) {
      return this
    }
    return this.update('notices', notices => {
      return notices.update(index, notice => {
        return notice.set('dismissed', true)
      })
    })
  }

  removeNotice(noticeId) {
    const index = this.findNoticeIndexById(noticeId)
    if (index === -1) {
      return this
    }
    return this.update('notices', notices => {
      return notices.splice(index, 1)
    })
  }

  appendNotice(options) {
    const notice = new ToastsNoticeRecord({
      id: this.lastId + 1,
      ...options
    })
    return this.merge({
      lastId: notice.id,
      notices: this.notices.push(notice)
    })
  }
}

ToastsRecord.reviver = keyedReviver(ToastsRecord, {
  notices: listReviver(ToastsNoticeRecord.reviver)
})

ToastsRecord.propTypes = {
  lastId: PropTypes.number,
  notices: PropTypes.arrayOf(
    PropTypes.shape(ToastsNoticeRecord.propTypes)
  )
}

module.exports = ToastsRecord
